import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { filter } from 'ramda';
import { FormattedMessage } from 'react-intl';

import Paper from 'components/Paper';
import HistoryCollapseContainer from 'containers/HistoryCollapseContainer';

import BottomFormControls from 'routes/Documents/components/BottomFormControls';

import MedicationHeader from './MedicationHeader';

import MedicationForm from './MedicationForm';
import VitaminForm from './VitaminForm';
import HistoryMapper, { sorter } from './HistoryMapper';
import MedicationDeletionHandler from './MedicationRemove';

import EditableV2 from 'routes/Documents/containers/EditableV2';
import { getLatestFinishedCommitData, getLatestUnfinishedCommit } from 'lib/documentHandling';

const Medication = ({ names, documents, editingDocument, onStartEdit, onCreate, viewId, onView }) => (
  <div>
    <Paper topMargin={false}>
      <Grid fluid>
        <MedicationHeader
          localeId={{
            title: 'medication.title',
            medication: 'medication.title.medication',
            vitamin: 'medication.title.vitamin',
          }}
          infoText="medication.infoText"
          editText={{ medication: 'medication.infoText.medication', vitamin: 'medication.infoText.vitamin' }}
          mode="create"
          editing={editingDocument}
          startEdit={name => onCreate(name)}
        />
      </Grid>
      {editingDocument && editingDocument.documentType === 'medication' && (
        <EditableV2
          documentId={editingDocument.documentId}
          moduleName={'medication'}
          editedCommit={getLatestUnfinishedCommit(editingDocument)}
        >
          <MedicationForm />
        </EditableV2>
      )}
      {editingDocument && editingDocument.documentType === 'vitamin' && (
        <EditableV2
          documentId={editingDocument.documentId}
          moduleName={'vitamin'}
          editedCommit={getLatestUnfinishedCommit(editingDocument)}
        >
          <VitaminForm />
        </EditableV2>
      )}
      {!editingDocument && viewId && viewId.name === 'medication' && (
        <MedicationForm
          editing={false}
          formValues={getLatestFinishedCommitData(documents.find(d => d.documentId === viewId.id))}
        />
      )}
      {!editingDocument && viewId && viewId.name === 'vitamin' && (
        <VitaminForm
          editing={false}
          formValues={getLatestFinishedCommitData(documents.find(d => d.documentId === viewId.id))}
        />
      )}

      {!editingDocument && !viewId && (
        <div>
          <h4
            style={{
              padding: '1rem',
              paddingLeft: '2rem',
              marginTop: '3rem',
              marginBottom: '-2rem',
              color: 'white',
              backgroundColor: '#81c5c0',
            }}
          >
            <FormattedMessage id="medication.headers.medication" />
          </h4>
          <HistoryCollapseContainer
            documents={filter(d => d.documentType === 'medication', documents)}
            emptyText="medication.emptyText"
            sorter={sorter}
            mapper={HistoryMapper('medication', onStartEdit, onView)}
            limit={3}
          />
          <h4
            style={{
              padding: '1rem',
              paddingLeft: '2rem',
              marginTop: '3rem',
              marginBottom: '-2rem',
              color: 'white',
              backgroundColor: '#81c5c0',
            }}
          >
            <FormattedMessage id="medication.headers.vitamin" />
          </h4>
          <HistoryCollapseContainer
            documents={filter(d => d.documentType === 'vitamin', documents)}
            emptyText="medication.emptyText"
            sorter={sorter}
            mapper={HistoryMapper('vitamin', onStartEdit, onView)}
            limit={3}
          />
        </div>
      )}
    </Paper>
    {editingDocument && (
      <BottomFormControls
        name={editingDocument.documentType}
        editId={editingDocument.documentId}
        commitId={getLatestUnfinishedCommit(editingDocument).commitId}
      />
    )}
    {<MedicationDeletionHandler editingDocument={editingDocument} />}
  </div>
);

Medication.propTypes = {
  names: PropTypes.array,
  documents: PropTypes.array,
  onStartEdit: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  viewId: PropTypes.object,
  onView: PropTypes.func,
};

export default Medication;
